import { SxProps, Theme } from '@mui/material/styles';
import { ReactNode } from 'react';
import { DatagridProps } from 'react-admin';

import { ExpandableDatagrid } from 'components/Datagrid';
import { HIDE_BELOW_SM, hasFields, LIVE_LOGS_I18N } from './liveLogs';
import { LiveLogsEmpty } from './LiveLogsEmpty';
import { LogFieldsPanel } from './LogFieldsPanel';

const DATAGRID_SX: SxProps<Theme> = {
  [`& .${HIDE_BELOW_SM}`]: { display: { xs: 'none', sm: 'table-cell' } },
};

interface LiveLogDatagridProps {
  children: ReactNode;
  rowSx?: DatagridProps['rowSx'];
}

/**
 * The grid every source shares: read-only (the authProvider has no canAccess, so the default would
 * add a BulkDeleteButton with checkboxes), no row click, every row with fields expandable through
 * the ExpandableDatagrid toggle in the first column.
 */
export const LiveLogDatagrid = ({ children, rowSx }: LiveLogDatagridProps) => (
  <ExpandableDatagrid
    bulkActionButtons={false}
    rowClick={false}
    expand={<LogFieldsPanel />}
    isRowExpandable={hasFields}
    toggleLabel={`${LIVE_LOGS_I18N}.expand.label`}
    empty={<LiveLogsEmpty />}
    rowSx={rowSx}
    sx={DATAGRID_SX}
  >
    {children}
  </ExpandableDatagrid>
);
